var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-card__finished"},[_c('div',{staticClass:"icon"},[_c('FinishIcon')],1),_c('div',{staticClass:"labels"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),(_vm.datetime)?_c('span',[_vm._v(_vm._s(_vm.datetime))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }